import { createReducer } from './utils';
import {
  STORES_LOADING,
  STORES_FAILURE,
  STORES_SUCCESS,
  SET_STORE,
  SET_STORE_NAME,
  STORE_NAME_LIST,
  SET_CHAIN,
  CHAIN_LIST,
  RESET_SEARCH_LIST,
  RESET_FILTER_LIST,
  LOG_OUT_REQUEST,
  LOG_OUT_SUCCESS,
  SET_STORE_LIST,
  SET_SUPPLIER,
  SUPPLIER_LOADING,
} from './constants';

const defaultState = {
  loading: false,
  loadingSupplier: false,
  stores: [],
  chains: [],
  storeNames: [],
  errorMessage: null,
  currentChain: '',
  currentStoreName: '',
  currentStoreIndex: 0,
  currentStore: '',
  firstLoad: true,
  prevStoreNames: [],
  supplierIds: [],
};

// reducer

export const reducer = createReducer(defaultState, {
  [STORES_LOADING]: handleStoreLoading,
  [STORES_FAILURE]: handleStoreFailure,
  [STORES_SUCCESS]: handleStoreSuccess,
  [SET_STORE]: handleSetStore,
  [SET_CHAIN]: handleSetChain,
  [CHAIN_LIST]: handleChainList,
  [SET_STORE_NAME]: handleSetStoreName,
  [SET_STORE_LIST]: handleSetStoreList,
  [STORE_NAME_LIST]: handleStoreNameList,
  [LOG_OUT_SUCCESS]: handleLogOutStores,
  [SET_SUPPLIER]: handleSetSupplier,
  [SUPPLIER_LOADING]: handleSupplierLoading,
});

function handleStoreLoading(state, action) {
  return {
    ...state,
    loading: true,
  };
}

function handleSupplierLoading(state, action) {
  return {
    ...state,
    loadingSupplier: true,
  };
}

function handleStoreFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    stores: [],
    errorMessage: error,
  };
}

function handleStoreSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    stores: response,
    firstLoad: false,
  };
}

function handleSetStore(state, { payload: { store, index } }) {
  return {
    ...state,
    currentStore: store,
    currentStoreIndex: index,
  };
}

function handleSetChain(state, { payload: { chain } }) {
  return {
    ...state,
    currentChain: chain,
  };
}

function handleChainList(state, { payload: { chains } }) {
  return {
    ...state,
    chains: chains,
  };
}

function handleSetStoreName(state, { payload: { storeName } }) {
  return {
    ...state,
    currentStoreName: storeName,
  };
}

function handleSetStoreList(state, { payload: { storeList } }) {
  return {
    ...state,
    storeNames: storeList,
  };
}

function handleStoreNameList(state, { payload: { names, previousNames } }) {
  return {
    ...state,
    storeNames: names,
    prevStoreNames: previousNames,
  };
}

function handleSetSupplier(state, { payload: { suppliers } }) {
  return {
    ...state,
    supplierIds: suppliers,
    loadingSupplier: false,
  };
}

function handleLogOutStores(state) {
  return {
    ...state,
    loading: false,
    loadingSupplier: false,
    stores: [],
    chains: [],
    storeNames: [],
    storeNamesFormat: [],
    errorMessage: null,
    currentChain: '',
    currentStoreName: '',
    currentStoreIndex: 0,
    currentStore: '',
    firstLoad: true,
    supplierIds: [],
  };
}

// actions

export function getStoresData() {
  return async (
    dispatch,
    getState,
    { services: { dataSource, authSource, storageSource } },
  ) => {
    dispatch({ type: STORES_LOADING });
    const {
      stores: { firstLoad },
    } = getState();

    try {
      const response = await dataSource.requestStores();

      if (response.length === 0) {
        dispatch({
          type: STORES_FAILURE,
          payload: {},
        });
        dispatch({ type: LOG_OUT_REQUEST });
        await authSource.logOut();
        dispatch({ type: LOG_OUT_SUCCESS });
        return;
      }

      if (firstLoad) {
        let i = 0;
        try {
          const saved = storageSource
            ? await storageSource.getItem('bruno_currentStore')
            : sessionStorage.getItem('bruno_currentStore');
          if (saved) {
            const found = response.findIndex(s => s.store === saved);
            if (found >= 0) i = found;
          }
        } catch (e) {
          // storage not available
        }

        dispatch({
          type: SET_STORE,
          payload: { store: response[i]['store'], index: i },
        });
        dispatch({ type: SET_CHAIN, payload: { chain: response[i]['chain'] } });
        dispatch({
          type: SET_STORE_NAME,
          payload: { storeName: response[i]['name'] },
        });
      }

      let chains = {};
      response.map((element, index) => {
        const chain = element.chain;
        const item = {
          store: element.store,
          name: element.name,
          index: index,
        };

        if (chains[chain]) {
          let chainList = chains[chain].slice();
          chainList.push(item);
          chains[chain] = chainList;
        } else {
          chains[chain] = [item];
        }
      });

      const {
        stores: { currentChain },
      } = getState();
      const activeChain = chains[currentChain]
        ? currentChain
        : response[0]['chain'];

      const names = chains[activeChain].map(element => ({
        index: element['index'],
        name: element['name'],
        store: element['store'],
        title: element['store'] + ' - ' + element['name'],
      }));

      dispatch({ type: STORE_NAME_LIST, payload: { names } });
      dispatch({ type: STORES_SUCCESS, payload: { response } });
      dispatch({ type: CHAIN_LIST, payload: { chains } });
    } catch (error) {
      console.log('getStoresData error', error);
      dispatch({
        type: STORES_FAILURE,
        payload: { error },
      });
    }
  };
}

export function getStoreNames(chain) {
  return async (dispatch, getState, { services: {} }) => {
    const {
      stores: { chains, currentChain },
    } = getState();

    const previousChainData = chains[currentChain];
    const previousNames = previousChainData.map(element => ({
      index: element['index'],
      name: element['name'],
      store: element['store'],
      title: element['store'] + ' - ' + element['name'],
    }));

    try {
      const chainsData = chains[chain];
      const names = chainsData.map(element => ({
        index: element['index'],
        name: element['name'],
        store: element['store'],
        title: element['store'] + ' - ' + element['name'],
      }));

      dispatch({ type: STORE_NAME_LIST, payload: { names, previousNames } });
    } catch (error) {
      console.log('getStoreNames error', error);
    }
  };
}

export function setChain(chain) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SET_CHAIN, payload: { chain } });
    } catch (error) {
      console.log('setChain error', error);
    }
  };
}

export function setStoreName(storeName) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SET_STORE_NAME, payload: { storeName } });
    } catch (error) {
      console.log('setStoreName error', error);
    }
  };
}

export function setStoreList(storeList) {
  return async (dispatch, getState, { services: {} }) => {
    try {
      dispatch({ type: SET_STORE_LIST, payload: { storeList } });
    } catch (error) {
      console.log('setStoreName error', error);
    }
  };
}

export function setStore(index) {
  return async (dispatch, getState, { services: { storageSource } }) => {
    const {
      stores: { stores },
    } = getState();

    try {
      const store = stores[index]['store'];
      try {
        if (storageSource) {
          await storageSource.setItem('bruno_currentStore', store);
        } else {
          sessionStorage.setItem('bruno_currentStore', store);
        }
      } catch (e) { /* storage not available */ }
      dispatch({ type: SET_STORE, payload: { store, index } });
      dispatch({ type: RESET_SEARCH_LIST });
      dispatch({ type: RESET_FILTER_LIST });
    } catch (error) {
      console.log('setStore error', error);
    }
  };
}

export function getSupplierId(store = null) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: SUPPLIER_LOADING });
    const {
      stores: { currentStore },
    } = getState();
    try {
      let response = [];
      if (store) {
        response = await dataSource.requestSupplier({ store: store });
      } else {
        response = await dataSource.requestSupplier({ store: currentStore });
      }

      let suppliers = response.suppliers;

      dispatch({ type: SET_SUPPLIER, payload: { suppliers } });
    } catch (error) {
      dispatch({ type: SET_SUPPLIER, payload: { suppliers: [] } });
      console.log('getSupplierId error', error);
    }
  };
}
